/**
 * Erreurs du module DT (Competency Folder / Dossier de Compétences)
 */

import { ERROR_CODES } from '@repo/contracts/errors';

import { ErrorConfigWithCallback } from './types';

export const DT_ERRORS: Record<string, ErrorConfigWithCallback> = {
    [ERROR_CODES.DT_IMPORT_DT_REFERENCES_DESCRIPTIONS_ALL_EMPTY]: {
        messageKey: 'cannot-import-dt-when-all-referenced-descriptions-are-empty',
        severity: 'error',
    },
    [ERROR_CODES.DT_IMPROVE_DT_NOT_FOUND]: {
        messageKey: 'unable-to-retrieve-the-dt-to-improve',
        severity: 'error',
    },
    [ERROR_CODES.DT_TEMPLATE_NOT_FOUND]: {
        messageKey: 'dt-word-template-not-found-you-can-add-one-in-admin-modules-and-select-competency-folder',
        severity: 'error',
    },
    [ERROR_CODES.DT_TEMPLATE_FILE_INVALID_FILE_TYPE]: {
        messageKey: 'the-template-file-must-be-in-docx-format',
        severity: 'error',
    },
    [ERROR_CODES.SUMMARY_TARGET_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-the-destination-of-the-summary-field-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.STRENGTHS_TARGET_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-the-destination-of-the-highlights-field-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.SOFTSKILLS_TARGET_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-the-destination-of-the-soft-skills-field-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.SKILLS_TARGET_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-the-destination-of-the-skills-field-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.MISCELLANEOUS_TARGET_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-the-destination-of-the-miscellaneous-field-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.SUMMARY_TARGET_ACTION_TYPE_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-incomplete-the-action-type-of-the-summary-field-destination-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.STRENGTHS_TARGET_ACTION_TYPE_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-incomplete-the-action-type-of-the-highlights-field-destination-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.SOFTSKILLS_TARGET_ACTION_TYPE_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-incomplete-the-action-type-of-the-soft-skills-field-destination-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.SKILLS_TARGET_ACTION_TYPE_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-incomplete-the-action-type-of-the-skills-field-destination-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.MISCELLANEOUS_TARGET_ACTION_TYPE_NOT_CONFIGURED]: {
        messageKey: 'export-impossible-incomplete-the-action-type-of-the-miscellaneous-field-destination-has-not-been-set-please-configure-it-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
    [ERROR_CODES.DT_TEMPLATE_FILE_NOT_FOUND]: {
        messageKey: 'word-export-impossible-the-template-has-not-been-uploaded-please-do-so-in-your-admin-panel-dt-tab',
        severity: 'error',
        closeDelay: 10000,
    },
};
